module.exports = __webpack_public_path__ + "img/pricing-info-mobile.3102cbd6.webp";